import React from "react";
import ToolkitProvider, {Search} from "react-bootstrap-table2-toolkit";
import {NavLink} from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import {euroFormat} from "../../../../utils/usefullFunctions";

const {SearchBar} = Search;
const columns = [
    {
        dataField: "projects_naw_id",
        text: "id",
        hidden: true,
    },
    {
        dataField: "projects_naw_company_name",
        text: "Bedrijf",
        formatter: (c, r) => <NavLink to={`/debtor/${r.projects_naw_id}`}>{c}</NavLink>,
        sort: true,
    },
    {
        dataField: "sum_outstanding_amount",
        text: "Openstaand",
        formatter: c => euroFormat(c),
        sort: true,
    },
    {
        dataField: "sum_overdue_amount",
        text: "Over tijd",
        formatter: c => euroFormat(c),
        classes: 'makeStyleRed',
        sort: true,
    },

];

const OpenstaandTable = ({data}) => {
    return <>
        <ToolkitProvider
            keyField="projects_naw_id"
            data={data}
            columns={columns}
            search
        >
            {(props) => (
                <>
                    <div className={"w-100 d-flex justify-content-between"}>
                        <SearchBar
                            className={"form-control wn-100"}
                            placeholder={"Filter: Typ om te zoeken"}
                            srText={null}
                            {...props.searchProps}
                        />
                    </div>
                    <hr/>
                    <BootstrapTable
                        {...props.baseProps}
                        pagination={paginationFactory()}
                    />
                </>
            )}
        </ToolkitProvider>
    </>
}

export default OpenstaandTable